import React from 'react'


import Navbar from '../Layouts/Navbar'
import SearchBy from '../Components/Search_Components/SearchBy'
import Footer from '../Layouts/Footer'

const SearchResult = () => {
  return (
    <div>
      <Navbar/>
      <SearchBy/>
      <Footer/>
    </div>
  )
}

export default SearchResult